import CarRentalContainer from '../../../../components/containers/CarRentalContainer';
import preloadCustomProps from '../../../utils/preloads/preloadCarRentalProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'car-rental-container',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: CarRentalContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
